<template>
  <div class="lm-container">
    <div class="lm-headline">
      <div>&nbsp;</div>
      <div  v-for="(quarter,index) in this.quarter" 
            :key="index"
            :style="{ 'font-weight': quarter.index === selectedQuarter ? 'bold' : 'regular' }">
        {{ getQuarterHeader(quarter) }}
      </div>
      <div>&nbsp;</div>
    </div>

    <div class="lm-line">
      <div>{{ headerText }}</div>
      <div  v-for="(quarter) in [1,2,3,4]" 
            :key="quarter"
            :style="{ 'font-weight': quarter === selectedQuarter ? 'bold' : 'regular' }">
        {{ getQuarterValue(quarter) }}
      </div>
      <div>&nbsp;</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    card:               { type: Object, default: undefined },
    fieldName:          { type: String, default: undefined },
    headerText:         { type: String, default: 'HEADER' },
    selectedQuarter:    { type: Number, default: undefined },
    selectedYear:       { type: Number, default: undefined }
  },

  data() {
    return {
      quarter: [ 
        { index: 1, label: 'Q1' },
        { index: 2, label: 'Q2' },
        { index: 3, label: 'Q3' },
        { index: 4, label: 'Q4' }
      ]
    }
  },

  methods: {
    getQuarterValue(quarter) {
      if (!this.card.quarterly)
        return '/';

      let item = this.card.quarterly.find(item => item.Quarter == quarter && item.Year === this.selectedYear);
      if (item) {
        return `${Math.round(item.FullfillmentRate * 1000) / 10}%` || '/';
      }
      return '/';
    },

    getQuarterHeader(quarter) {
      let result = quarter.label;
      if (this.selectedYear) {
        result += `/${this.selectedYear}`;
      }
      return result;
    }
  }
}
</script>

<style lang="scss" scoped>
  .lm-line, .lm-headline {
    grid-template-columns: 3fr 1fr 1fr 1fr 1fr 2fr;
  }
</style>